import { parseImageJSON as e } from "./parseImageJSON.es.js";
import { CONFIG as t } from "../config.es.js";
//#region lib/Image/lib/consumes.ts
var n = ({ input: n }) => {
	if (n.type === "core/image" && typeof n.data == "string" && e(n.data)) return [!0, "core/image"];
	if (!(n.data instanceof File)) return [!1];
	let { size: r, type: i } = n.data;
	return [
		"image/png",
		"image/jpg",
		"image/jpeg",
		"image/gif"
	].includes(i) ? r / 1024 / 1024 > t.maxSizeInMb ? (console.warn(`Image is too large, ${r / 1024 / 1024}, max ${t.maxSizeInMb} Mb allowed`), [!1]) : [
		!0,
		"core/image",
		!1
	] : [!1];
};
//#endregion
export { n as consumes };
